import React from "react";
import { Badge } from "./KeyBadge.styles";
import type { KeyBadgeProps } from "./KeyBadge.types";

export const KeyBadge: React.FC<KeyBadgeProps> = ({
  kind,
  label,
  className,
}) => (
  <Badge $kind={kind} className={className}>
    {label ?? kind}
  </Badge>
);

export default KeyBadge;
